import { Emitter, Event } from "../../../base/common/events.js";
import { Disposable } from "../../../base/common/lifecycle.js";
import { SyncDescriptor } from "../../instantiation/common/descriptors.js";
import { ILogService } from "../../log/common/log.js";
import { AIPersona, AIServiceChangedEvent, IAIContextService, IAIService, IAISystemProvider, IAIToolService } from "./ai.js";



export class AIService extends Disposable implements IAIService {

    private readonly _onDidChange = new Emitter<AIServiceChangedEvent>();
    readonly onDidChange = this._onDidChange.event;
    private readonly _providers: IAISystemProvider[] = [];

    constructor(
        @ILogService protected readonly logger: ILogService,
        @IAIContextService public readonly contextService: IAIContextService,
        @IAIToolService public readonly toolService: IAIToolService,
    ) {
        super();
        logger.debug("AI Service initialized with context and tool services.");
    }

    getProvider(persona: AIPersona): IAISystemProvider | null {

        for (const provider of this._providers) {
            if (provider.persona === persona) {
                return provider;
            }
        }

        return null;
    }

    async registerProvider(provider: IAISystemProvider): Promise<void> {

        if (!provider) {
            this.logger.warn("Attempted to register null or undefined AI system provider.");
            return;
        }

        if (!this._providers.includes(provider)) {
            this.logger.debug(`Registering AI system provider for persona '${provider.persona}'.`);
            this._providers.push(provider);
            this._onDidChange.fire({ service: this });
        }
    }



}